import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CaseDetail from '../views/CaseDetail.vue'
import Intellectual from '../views/Intellectual.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/case-detail/:id',
    name: 'CaseDetail',
    component: CaseDetail,
    props: true
  },
  {
    path: '/intellectual',
    name: 'Intellectual',
    component: Intellectual
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
